import { jsxs as i, jsx as l } from "react/jsx-runtime";
import { getIconStyles as C } from "../styles.js";
const t = (e) => /* @__PURE__ */ i(
  "svg",
  {
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: C(e),
    children: [
      /* @__PURE__ */ l("g", { clipPath: "url(#clip0_3928_22220)", children: /* @__PURE__ */ l(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M1.13348 9.27849C-0.367411 10.7794 -0.367411 13.2128 1.13348 14.7137L9.2863 22.8665C10.7872 24.3674 13.2206 24.3674 14.7215 22.8665L22.8743 14.7137C24.3752 13.2128 24.3752 10.7794 22.8743 9.27849L14.7215 1.12567C13.2206 -0.375223 10.7872 -0.375223 9.2863 1.12567L1.13348 9.27849ZM12 17.9961C15.3137 17.9961 18 15.3098 18 11.9961C18 8.68239 15.3137 5.99609 12 5.99609C8.68629 5.99609 6 8.68239 6 11.9961C6 15.3098 8.68629 17.9961 12 17.9961ZM11.4065 14.5357C11.1136 14.8286 11.1136 15.3035 11.4065 15.5964C11.6994 15.8893 12.1743 15.8893 12.4671 15.5964L15.4699 12.5937C15.7627 12.3008 15.7627 11.8259 15.4699 11.533L12.4665 8.53046C12.1736 8.23757 11.6987 8.23757 11.4058 8.53046C11.1129 8.82335 11.1129 9.29823 11.4058 9.59112L13.8785 12.0638L11.4065 14.5357ZM8.5185 13.5204C8.22561 13.8133 8.22561 14.2882 8.5185 14.5811C8.81139 14.874 9.28626 14.874 9.57916 14.5811L11.566 12.5942C11.8589 12.3013 11.8589 11.8264 11.566 11.5335L9.57918 9.54664C9.28629 9.25375 8.81142 9.25375 8.51852 9.54664C8.22563 9.83954 8.22563 10.3144 8.51852 10.6073L9.97506 12.0638L8.5185 13.5204Z",
          fill: "currentColor"
        }
      ) }),
      /* @__PURE__ */ l("defs", { children: /* @__PURE__ */ l("clipPath", { id: "clip0_3928_22220", children: /* @__PURE__ */ l("rect", { width: "24", height: "24", fill: "white" }) }) })
    ]
  }
);
export {
  t as DiamondArrowsIcon
};
//# sourceMappingURL=DiamondArrowsIcon.js.map
